import { IconContent } from '@icons';

export const squareOnSquareWithArrow: IconContent = {
    sm: '<path fill-rule="evenodd" d="M3 9.5h2.5V13h8V5h-8v1.5C5.5 7.33 6.17 8 7 8h3.3L9.14 6.85l.7-.7 2.36 2.35-2.36 2.35-.7-.7L10.29 9H7a2.5 2.5 0 0 1-2.5-2.5V4H10V2.5H3v7ZM11 4V1.5H2v9h2.5V14h10V4H11Z"/>',
};
